import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { RecentlyVisitedPages, PageType } from "../../scripts/common/ah.mb.common.stored-stack";

@Component
export default class ConvegenceWatcher extends Vue {

    @Prop()
    jobId: string;


 savePageToRecentItems(jobId: string) {

    // Add page to recent list
    if (jobId) {
        const recentItemsStore = new RecentlyVisitedPages();
        recentItemsStore.stack.add(
            {
                modelId: jobId,
                pageType: PageType.ConvergenceGraph,
                name: "Convergence Graph",
                visitedDate: new Date()
            });
    };

}



/* Set element sizes for ones where we can't get the fuckin css to do it for us
This is called on resize, and also after adminlte sidebar collapse/expand */
setControlSizes (){

    const parent = $(".content-wrapper");

    const footer = $("footer");

    const buttonsRow = $("#chartHeader");

    const mainHeader = $(".main-header");
    const header = $(".content-header");

    const margins = 12;

    const windowHeight = $(window).height();

    const treeHeight = windowHeight -
        footer.outerHeight() -
        buttonsRow.outerHeight() -
        header.outerHeight() -
        mainHeader.outerHeight();

    //console.clear();
    //console.log('windowHeight', windowHeight);

    //console.log('buttonsRow.height()', buttonsRow.height());
    //console.log('$(window).height()', $(window).height());
    //console.log('footer.outerHeight()', footer.outerHeight());

    //console.log('parent.outerHeight()', parent.outerHeight());
    //console.log('parent.height()', parent.height());
    //console.log('mainHeader.outerHeight', mainHeader.outerHeight());
    //console.log('header.outerHeight()', header.outerHeight());
    //console.log('buttonsRow.outerHeight()', buttonsRow.outerHeight());

    //console.log('treeHeight', treeHeight);

    const viewDiv = $(".content");

    //console.log('*** WIDTHS ***');
    //console.log('parent.outerWidth()', parent.outerWidth());
    //console.log('viewDiv.outerWidth()', viewDiv.outerWidth());

    const chartDiv = $("#chartDiv");
    chartDiv.width(viewDiv.width());

    chartDiv.height(treeHeight - (margins * 3) - 40);// Arbitrary fudge fix
}


    mounted() {

        this.savePageToRecentItems(this.jobId);



    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/convergence-watcher/convergence-watcher.ts